/* global bootstrap */

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';

window.flatpickr = flatpickr;
window.rangePlugin = rangePlugin;

document.addEventListener('DOMContentLoaded', () => {
    const toast = document.getElementById('copy-toast');

    function showToast(message = 'Copied') {
        toast.textContent = message;
        toast.style.display = 'block';
        setTimeout(() => toast.style.opacity = '1', 10);

        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                toast.style.display = 'none';
            }, 300);
        }, 1000);
    }

    document.querySelectorAll('.copy-text').forEach(el => {
        let isShow = el.dataset.copy;

        if (!isShow) {
            el.classList.add('d-none')
            return
        }

        el.addEventListener('click', () => {
            navigator.clipboard.writeText(el.dataset.copy)
                .then(() => showToast())
                .catch(() => showToast('Could not copy'));
        });
    });

    // tooltip
    document.querySelectorAll('[data-tooltip-text]').forEach(el => {
        if (el.scrollWidth > el.offsetWidth) {
            el.setAttribute('title', el.getAttribute('data-tooltip-text'));
            new bootstrap.Tooltip(el);
        }
    });
    document.querySelectorAll('[data-tooltip-always-text]').forEach(el => {
        el.setAttribute('title', el.getAttribute('data-tooltip-always-text'));
        new bootstrap.Tooltip(el);
    });

    // redirect to first page when perPage value is changed to avoid empty pages
    const perPageSelect = document.querySelector('.form-select[name="perPage"]');

    if (perPageSelect)
        perPageSelect.addEventListener('change', (el) => {
            const params = new URLSearchParams(window.location.search);
            params.set('page', 1);
            params.set('perPage', el.target.value);
            window.location.search = params.toString();
        });


// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// Script for displaying text with short display effect and full size expansion

    let resizeObserver = null;

    function checkShowButton(block) {
        if (!block) return;

        const style = getComputedStyle(block);
        const lineHeight = parseFloat(style.lineHeight);
        if (isNaN(lineHeight) || lineHeight <= 0) {
            block.classList.remove('show-btn');
            return;
        }

        const maxLines = parseInt(block.dataset.maxLines) || 3;
        const maxHeight = lineHeight * maxLines;
        block.classList.toggle('show-btn', block.scrollHeight > maxHeight + 2);
    }

    function initTextBlock(block) {
        const wasExpanded = block.classList.contains('expanded');

        // Remove existing buttons
        block.querySelectorAll('.more-btn, .less-btn').forEach(btn => btn.remove());

        // Reset classes
        block.classList.remove('collapsed', 'expanded');

        // Set max lines
        const maxLines = parseInt(block.dataset.maxLines) || 3;
        block.style.setProperty('--max-lines', maxLines);

        // Create buttons
        const moreBtn = document.createElement('button');
        moreBtn.classList.add('more-btn');
        moreBtn.innerHTML = '... <i class="ti ti-chevrons-right"></i>';

        const lessBtn = document.createElement('button');
        lessBtn.classList.add('less-btn');
        lessBtn.innerHTML = '<i class="ti ti-chevrons-left"></i>';

        // Append buttons
        block.append(moreBtn, lessBtn);

        // Set initial state
        block.classList.add(wasExpanded ? 'expanded' : 'collapsed');

        // Check if buttons should be visible
        checkShowButton(block);

        // Event listeners for buttons
        moreBtn.addEventListener('click', () => {
            event.stopPropagation();
            block.classList.remove('collapsed');
            block.classList.add('expanded');
            checkShowButton(block);
        });

        lessBtn.addEventListener('click', () => {
            event.stopPropagation();
            block.classList.remove('expanded');
            block.classList.add('collapsed');
            checkShowButton(block);
        });

        // Initialize ResizeObserver
        if (!resizeObserver) {
            resizeObserver = new ResizeObserver(() => {
                document.querySelectorAll('.text-with-more').forEach(checkShowButton);
            });
        }

        // Observe the block
        resizeObserver.observe(block);
    }

    function initAllTextWithMore() {
        document.querySelectorAll('.text-with-more').forEach(block => {
            initTextBlock(block);

            // Watch for content changes
            const observer = new MutationObserver(() => {
                block.classList.remove('expanded');
                block.classList.add('collapsed');
                checkShowButton(block);
            });

            observer.observe(block, {
                childList: true,
                characterData: true,
                subtree: true
            });
        });
    }

    // Cleanup on window unload
    window.addEventListener('unload', () => {
        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    });

    window.initAllTextWithMore = initAllTextWithMore;
    initAllTextWithMore();

    // ---------------------------------------------------------------------------
    // ---------------------------------------------------------------------------
    // SAVE STATE for accordion

    const currentPath = location.pathname;
    const storageKey = "accordion_states";
    const lastPageKey = "last_page_path";

    function safeParse(json) {
        try {
            return JSON.parse(json);
        } catch {
            return {};
        }
    }

    const allStates = safeParse(sessionStorage.getItem(storageKey)) || {};
    const pageStates = allStates[currentPath] || {};

    const accordions = document.querySelectorAll(".accordion.saved-state");

    document.querySelectorAll(".accordion.saved-state .accordion-collapse").forEach(collapseEl => {
        const collapseId = collapseEl.id;
        if (!collapseId) return;

        if (pageStates[collapseId] === "open") {
            new bootstrap.Collapse(collapseEl, {show: true, toggle: true});
        } else if (!pageStates[collapseId] && collapseEl.classList.contains("default-show")) {
            // если ещё нет сохранённого состояния, но стоит default-open
            new bootstrap.Collapse(collapseEl, {show: true, toggle: true});
        }

        collapseEl.addEventListener("shown.bs.collapse", function () {
            allStates[currentPath] = allStates[currentPath] || {};
            allStates[currentPath][collapseId] = "open";
            sessionStorage.setItem(storageKey, JSON.stringify(allStates));
        });

        collapseEl.addEventListener("hidden.bs.collapse", function () {
            allStates[currentPath] = allStates[currentPath] || {};
            allStates[currentPath][collapseId] = "closed";
            sessionStorage.setItem(storageKey, JSON.stringify(allStates));
        });
    });

    const lastPage = sessionStorage.getItem(lastPageKey);
    if (lastPage && lastPage !== currentPath) {
        delete allStates[lastPage];
        sessionStorage.setItem(storageKey, JSON.stringify(allStates));
    }

    sessionStorage.setItem(lastPageKey, currentPath);

    accordions.forEach(acc => acc.classList.add("js-ready"));

    // Автоматическое обновление CSRF токена #42252
    setInterval(function () {
        fetch('/refresh-csrf')
            .then(response => response.json())
            .then(data => {
                document.querySelector('meta[name="csrf-token"]').setAttribute('content', data.token);
                // Обновляем токен в формах
                document.querySelectorAll('input[name="_token"]').forEach(input => {
                    input.value = data.token;
                });
            });
    }, 720 * 60 * 1000); // Каждые 12 часов (24 часа установлена сессия)
});
